import React, { useEffect, useRef } from 'react';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import AnalyticsScripts from 'components/AnalitycsScripts';

import * as Sentry from '@sentry/react';

import { DEV_MODE, NODE_ENV } from './const';
import Booking from './pages/booking';
import RootProvider from './providers';
import './styles/globals.scss';

if (!DEV_MODE) {
	Sentry.init({
		dsn: 'https://844ecf21e20b48cfbb507cda5542ae21@o87107.ingest.sentry.io/6066698',
		environment: NODE_ENV,
		release: '2022-08-03',
	});
}

function App() {
	/* const isSentRef = useRef(false);
	useEffect(() => {
		if (!isSentRef.current) {
			sendAnalytics().then(() => {
				isSentRef.current = true;
			});
		}
	}, []); */

	return (
		<RootProvider>
			<BrowserRouter>
				<AnalyticsScripts />
				<Routes>
					<Route path={`/booking${DEV_MODE ? '' : '/:clientId'}`} element={<Booking />}>
						<Route path=":guid" element={<Booking />} />
					</Route>
				</Routes>
			</BrowserRouter>
		</RootProvider>
	);
}

export default App;
